import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { hasRequiredRole, redirectToErp } from 'constants/auth';

const PrivateRoute = ({ isAuthenticated, ...rest }) => {
  useEffect(() => {
    if (!isAuthenticated || !hasRequiredRole()) {
      redirectToErp();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated || !hasRequiredRole()) {
    return null;
  }

  return <Route {...rest} />;
};

PrivateRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

export default PrivateRoute;
